import { renderRoot } from 'quartz-core/client';
import UIApplication from 'UIComponents/app/UIApplication';

// I18n Configuration
import setDocumentTitle from 'I18n/utils/setDocumentTitle';

// Import extra I18n data
import 'I18n/init/data/currency';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllPublicData';

// Rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// Redux

import { Provider } from 'react-redux';
import { configureStore } from './utils/configureStore';
import { startApp } from './actions/AppActions';
import { getAuth } from './actions/AuthActions';

// Configure the router
import { Router } from 'react-router-dom';
import { Routes } from './components/Routes';
import { getHistory } from './utils/history';
import { getPreferredLocale } from './i18n/localeUtils';
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import PortalIdParser from 'PortalIdParser';
import { ApplicationWrapper } from './components/ApplicationWrapper';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export class App {
  constructor() {
    this.store = configureStore();
  }
  // Kicks off the app. This is intentionally not in the constructor.
  async start() {
    const locale = getPreferredLocale();
    const I18nPublicProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    I18nPublicProvider.setLocale({
      locale,
      langEnabled: true
    });
    await Promise.all([this.startAuth(), I18nPublicProvider.register(lang), registerAllData(I18nPublicProvider)]);
    setDocumentTitle('app.htmlTitle');
    this.store.dispatch(startApp());
    this.startRouter();
  }
  startAuth() {
    return PortalIdParser.get() ? this.store.dispatch(getAuth()) : Promise.resolve();
  }
  startRouter() {
    const history = getHistory();
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "embedded-viral-link-ui",
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-transparent-default",
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(RhumbProvider, {
            history: historyAdapter(history),
            config: rhumbConfig,
            children: /*#__PURE__*/_jsx(Router, {
              history: history,
              children: /*#__PURE__*/_jsx(ApplicationWrapper, {
                children: /*#__PURE__*/_jsx(Routes, {})
              })
            })
          })
        })
      })
    }));
  }
}